import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Dropdown } from "semantic-ui-react";

const LevelColourDropdown = (props) => {
    const { onChange, value, disabled, id } = props;
    const { t } = useTranslation();
    const list = [
        {
            text: <FontAwesomeIcon icon={faCircle} className="class-lvl-MediumVioletRed" />,
            value: "MediumVioletRed",
            key: 1,
        },
        {
            text: <FontAwesomeIcon icon={faCircle} className="class-lvl-Orange" />,
            value: "Orange",
            key: 2,
        },
        {
            text: <FontAwesomeIcon icon={faCircle} className="class-lvl-Gold" />,
            value: "Gold",
            key: 3,
        },
        {
            text: <FontAwesomeIcon icon={faCircle} className="class-lvl-DarkKhaki" />,
            value: "DarkKhaki",
            key: 4,
        },
        {
            text: <FontAwesomeIcon icon={faCircle} className="class-lvl-YellowGreen" />,
            value: "YellowGreen",
            key: 5,
        },
        {
            text: <FontAwesomeIcon icon={faCircle} className="class-lvl-LimeGreen" />,
            value: "LimeGreen",
            key: 6,
        },
        {
            text: <FontAwesomeIcon icon={faCircle} className="class-lvl-LightSeaGreen" />,
            value: "LightSeaGreen",
            key: 7,
        },
        {
            text: <FontAwesomeIcon icon={faCircle} className="class-lvl-DeepSkyBlue" />,
            value: "DeepSkyBlue",
            key: 8,
        },
        {
            text: <FontAwesomeIcon icon={faCircle} className="class-lvl-SlateBlue" />,
            value: "SlateBlue",
            key: 9,
        },
        {
            text: <FontAwesomeIcon icon={faCircle} className="class-lvl-MediumOrchid" />,
            value: "MediumOrchid",
            key: 10,
        },
        {
            text: <FontAwesomeIcon icon={faCircle} className="class-lvl-HotPink" />,
            value: "HotPink",
            key: 11,
        },
        {
            text: <FontAwesomeIcon icon={faCircle} className="class-lvl-LightCoral" />,
            value: "LightCoral",
            key: 12,
        },
        {
            text: <FontAwesomeIcon icon={faCircle} className="class-lvl-Crimson" />,
            value: "Crimson",
            key: 13,
        },
        {
            text: <FontAwesomeIcon icon={faCircle} className="class-lvl-Chocolate" />,
            value: "Chocolate",
            key: 14,
        },
        {
            text: <FontAwesomeIcon icon={faCircle} className="class-lvl-LightSlateGray" />,
            value: "LightSlateGray",
            key: 15,
        },
    ];

    return (
        <Fragment>
            <Dropdown
                disabled={disabled}
                className="size-sm colour-dropdown"
                placeholder={t("lack")}
                fluid
                selection
                options={list}
                onChange={(e, data) => onChange(data.value)}
                value={value}
                id={id}
            />
        </Fragment>
    );
};

export default LevelColourDropdown;
